import { render, staticRenderFns } from "./side-video.vue?vue&type=template&id=74d37262&scoped=true"
import script from "./side-video.vue?vue&type=script&lang=js"
export * from "./side-video.vue?vue&type=script&lang=js"
import style0 from "./side-video.vue?vue&type=style&index=0&id=74d37262&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d37262",
  null
  
)

export default component.exports